import type { TvProgramType } from '@funtech-int/kp-graphql-sdk/yango-movies-www';

import { I18n } from '../../hooks/useI18n';

const getTvProgramTypeNameMap = (i18n: I18n) => ({
    MOVIE: i18n('channels_tv_program_movie'),
    SERIES: i18n('channels_tv_program_series'),
    SHOW: i18n('channels_tv_program_show'),
    SPORT: i18n('channels_tv_program_sport'),
});

export const transformTvProgramTypeNameMap = (
    typeName: TvProgramType | null | undefined,
    i18n: I18n
): string | undefined => (typeName && getTvProgramTypeNameMap(i18n)[typeName]) || undefined;
